export default function EllipsisDots({ ...rest }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.72228 1.94444C7.72228 2.374 8.0705 2.72222 8.50005 2.72222C8.92961 2.72222 9.27783 2.374 9.27783 1.94444C9.27783 1.51489 8.92961 1.16667 8.50005 1.16667C8.0705 1.16667 7.72228 1.51489 7.72228 1.94444Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M7.72228 8.5C7.72228 8.92955 8.0705 9.27778 8.50005 9.27778C8.92961 9.27778 9.27783 8.92955 9.27783 8.5C9.27783 8.07045 8.92961 7.72222 8.50005 7.72222C8.0705 7.72222 7.72228 8.07045 7.72228 8.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M7.72228 15.0556C7.72228 15.4851 8.0705 15.8333 8.50005 15.8333C8.92961 15.8333 9.27783 15.4851 9.27783 15.0556C9.27783 14.626 8.92961 14.2778 8.50005 14.2778C8.0705 14.2778 7.72228 14.626 7.72228 15.0556Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}
